import { SegmentedControl as $SegmentedControl } from '@mantine/core';
import type { SegmentedControlProps as $SegmentedControlProps } from '@mantine/core';
import { useController } from 'react-hook-form';
import type { FieldValues, UseControllerProps } from 'react-hook-form';

type SegmentedControlProps<T extends FieldValues> = UseControllerProps<T> &
  Omit<$SegmentedControlProps, 'values' | 'defaultValues'>;

export function SegmentedControl<T extends FieldValues>({
  name,
  control,
  defaultValue,
  rules,
  shouldUnregister,
  onChange,
  ...props
}: SegmentedControlProps<T>) {
  const {
    field: { value, onChange: fieldOnChange, ref: _fieldRef, ...field },
  } = useController<T>({
    name,
    control,
    defaultValue,
    rules,
    shouldUnregister,
  });

  return (
    <$SegmentedControl
      value={value}
      onChange={(e) => {
        fieldOnChange(e);
        onChange?.(e);
      }}
      {...field}
      {...props}
    />
  );
}
